import React from 'react';
import { QuickLink } from '../types';
import LinkList from './LinkList';

interface QuickLinksProps {
  links: QuickLink[];
  onDelete: (id: string) => void;
  onOpenModal: () => void;
  isAdmin?: boolean;
  onAdd?: (title: string, url: string) => void;
}

const QuickLinks: React.FC<QuickLinksProps> = ({ links, onDelete, onOpenModal, isAdmin, onAdd }) => (
  <LinkList
    links={links}
    onDelete={onDelete}
    onAdd={onAdd}
    onOpenModal={onOpenModal}
    isAdmin={isAdmin}
    addButtonText="Add Link"
    emptyText="No links yet. Click + to add."
    maxHeight="max-h-48"
  />
);

export default QuickLinks;